import { AWDeepDiveProposalTabs } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { userPreferenceApi } from './Base';

export type UpdateOrCreateDeepDiveProposalTabsType = Omit<AWDeepDiveProposalTabs, 'userPreferenceMetadata'>;

export async function getAllDeepDiveProposalTabs(pkg: string) {
  const path = '/v1/deep-dive-proposal-tabs';
  const response = await userPreferenceApi.get<AGraphWrappedType<AWDeepDiveProposalTabs[], 'deepDiveProposalTabs'>>(
    path,
    {
      params: { pkg },
    }
  );
  return unwrapAGraphResponse(response, 'deepDiveProposalTabs');
}

export async function postCreateDeepDiveProposalTab(preference: UpdateOrCreateDeepDiveProposalTabsType, pkg: string) {
  const path = '/v1/deep-dive-proposal-tabs';
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'id'>>(path, preference, { params: { pkg } });
  return unwrapAGraphResponse(response, 'id');
}

export function deleteAllDeepDiveProposalTabs() {
  const path = '/v1/deep-dive-proposal-tabs';
  return userPreferenceApi.delete<void>(path);
}

export async function getDeepDiveProposalTab(aggIdTag: string, aggIdValue: string) {
  const path = `/v1/deep-dive-proposal-tabs/${aggIdTag}/${aggIdValue}`;
  const response =
    await userPreferenceApi.get<AGraphWrappedType<AWDeepDiveProposalTabs[], 'deepDiveProposalTabs'>>(path);
  return unwrapAGraphResponse(response, 'deepDiveProposalTabs');
}

export async function putUpdateDeepDiveProposalTabs(
  aggIdTag: string,
  aggIdValue: string,
  updatedPreference: UpdateOrCreateDeepDiveProposalTabsType,
  pkg: string
) {
  const path = `/v1/deep-dive-proposal-tabs/${aggIdTag}/${aggIdValue}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'id'>>(path, updatedPreference, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'id');
}

export function deleteDeepDiveProposalTab(aggIdTag: string, aggIdValue: string) {
  const path = `/v1/deep-dive-proposal-tabs/${aggIdTag}/${aggIdValue}`;
  return userPreferenceApi.delete<void>(path);
}
